<div class="AY">
    <div class="AY__header">
        Please tell us about <br/> yourself
    </div>
    <form class="AY__content" @submit.prevent="onSubmit">
        <div class="AY__name">
            <input-container class="AY__fn" :dirtyForm="$v.$dirty">
                <div class="AY__label">First name</div>
                <div class="AY__firstName">
                    <text-field class="input-field" :error="hasError('firstName')"
                        v-model="firstName"></text-field>
                </div>
                <mom-error v-if="!$v.firstName.required">First name is required.</mom-error>
            </input-container>
            <input-container :dirtyForm="$v.$dirty">
                <div class="AY__label">Last name</div>
                <div class="AY__lastName">
                    <text-field class="input-field" :error="hasError('lastName')"
                        v-model="lastName"></text-field>
                </div>
                <mom-error v-if="!$v.lastName.required">Last name is required.</mom-error>
            </input-container>
        </div>
        <input-container :dirtyForm="$v.$dirty">
            <div class="AY__label">Mobile number</div>
            <div class="AY__mobile">
                <telephone-input class="AY__mobile-input"
                    v-model="mobileNumber" :error="hasError('mobileNumber')">
                </telephone-input>
            </div>
            <mom-error v-if="!$v.mobileNumber.required">Mobile number is required.</mom-error>
            <mom-error v-else-if="!$v.mobileNumber.isNumeric">Mobile number should not contain alphabets.</mom-error>
            <mom-error v-else-if="!$v.mobileNumber.isValidInput">Mobile number should be min 4 and max 13 digits long.</mom-error>
        </input-container>

        <input-container :dirtyForm="$v.$dirty">
            <div class="AY__label">Timezone</div>
            <auto-select class="input-field"
                :toText="toText"
                v-model="selectedTimezone" :options="timezoneOpts"
                @search="onSearch('timezoneSearch', $event)" :error="hasError('selectedTimezone')">
            </auto-select>
            <mom-error v-if="!$v.selectedTimezone.isValidInput">Please enter a valid timezone.</mom-error>
        </input-container>

        <div class="AY__proceed">
            <mom-button type="submit" variant="raised">Next</mom-button>
        </div>
    </form>
</div>